/**
 * Generated by orval v8.16.0 🍺
 * Do not edit manually.
 * FinPath API
 * Backend API programu FinPath (panel admina + aplikacja mobilna).
 * OpenAPI spec version: 0.1.0
 */

/**
 * * `concrete` - konkretny produkt
 * * `nominal` - nominalny
 * * `optional` - otwarty
 */
export type GoalAnchorEnum = typeof GoalAnchorEnum[keyof typeof GoalAnchorEnum];


export const GoalAnchorEnum = {
  concrete: 'concrete',
  nominal: 'nominal',
  optional: 'optional',
} as const;
